import { ComponentProps, useMemo } from 'react';
import { Platform, Pressable, StyleSheet, View } from 'react-native';
import { Link as LinkLib, useLinkProps } from '@react-navigation/native';

import { colors, spacing } from '../../theme';
import { usePressable } from '../../hooks';

type Props = ComponentProps<typeof LinkLib>;

export const Link = ({ action, children, style, screen, params, ...linkProps }: Props) => {
	const { onPress, ...props } = useLinkProps({ screen, params, action });
	const { isHovered, onHoverIn, onHoverOut } = usePressable();

	const mainStyles = useMemo(() => {
		return [styles.root, style, isHovered && styles.hovered];
	}, [isHovered, style]);

	if (Platform.OS === 'web') {
		return (
			<Pressable
				onPress={onPress}
				onHoverIn={onHoverIn}
				onHoverOut={onHoverOut}
				style={mainStyles}
				role="link"
				{...linkProps}
			>
				{children}
				<View style={[styles.line, isHovered && styles.hoveredLine]} />
			</Pressable>
		);
	}

	return (
		<LinkLib
			action={action}
			screen={screen}
			params={params}
			{...linkProps}
			{...props}
			style={mainStyles}
		>
			{children}
		</LinkLib>
	);
};

const styles = StyleSheet.create({
	root: {
		transitionDuration: '150ms',
		opacity: 1,
	},
	line: {
		width: 22,
		height: 2,
		backgroundColor: colors.primary,
		borderRadius: spacing(0.5),
		position: 'absolute',
		bottom: 4,
		transitionDuration: '150ms',
	},
	hoveredLine: {
		width: '100%',
	},
	hovered: {
		opacity: 0.85,
	},
});
